__turbopack_context__.v({
  "articleBody": "SingleBlogContent-module-scss-module__AdlxrG__articleBody",
  "container": "SingleBlogContent-module-scss-module__AdlxrG__container",
  "containerWrapper": "SingleBlogContent-module-scss-module__AdlxrG__containerWrapper",
  "content": "SingleBlogContent-module-scss-module__AdlxrG__content",
  "dateInfo": "SingleBlogContent-module-scss-module__AdlxrG__dateInfo",
  "root": "SingleBlogContent-module-scss-module__AdlxrG__root",
  "sidebar": "SingleBlogContent-module-scss-module__AdlxrG__sidebar",
  "sidebarWrapper": "SingleBlogContent-module-scss-module__AdlxrG__sidebarWrapper",
});
